module.exports = __webpack_public_path__ + "img/interaction.193394c2.svg";